export default function GameStatsText({ text, value }: { text: string; value: string | number }): React.ReactElement {
  return (
    <div className="flex flex-col gap-1">
      <p className="text-xxs text-gray-400">{text}</p>
      <p className="text-white">{value}</p>
    </div>
  )
}
